import { AxiosConfigBenchmarking } from "Benchmarking/Config/AxiosConfig";

export const getAuthorRanking = (filters, callback) => {
  const axios = AxiosConfigBenchmarking();
  const url = "/author/rank";
  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getFacultySuggestSearch = (param, callback) => {
  const axios = AxiosConfigBenchmarking();
  const url = `/authors/suggest/${param}`;
  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getSearchAuthors = (filters, callback) => {
  const axios = AxiosConfigBenchmarking();
  let url = `/author/search`;

  axios
    .post(url, filters)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getSearchKeywords = (query, domain, callback) => {
  const axios = AxiosConfigBenchmarking();
  let url = `/search/keywords/${query}`;

  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getCompareFaculties = (params, callback) => {
  const axios = AxiosConfigBenchmarking();
  let url = `/search/keywords/${params}`;

  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getFacultyExplore = (callback) => {
  const axios = AxiosConfigBenchmarking();
  let url = `/authors/explore`;

  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getFacultySummaryById = (id, callback) => {
  const axios = AxiosConfigBenchmarking();
  let url = `/author/summary/?authorId=${id}`;

  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getFacultyBaseStatisticById = (id, callback) => {
  const axios = AxiosConfigBenchmarking();
  let url = `/author/base_stats/?authorId=${id}`;

  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getFacultyAdvanceStatisticById = (id, callback) => {
  const axios = AxiosConfigBenchmarking();
  let url = `/author/advanced_stats/?authorId=${id}`;

  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getFacultyCompare = (authorIds, callback) => {
  let ids = "";
  authorIds.map((item, index) => {
    if (index == authorIds.length - 1) {
      ids += "authorIds=" + item.id;
    } else {
      ids += "authorIds=" + item.id + "&";
    }
  });
  const axios = AxiosConfigBenchmarking();
  let url = `/author/compare/?${ids}`;
  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getFacultyConceptMapById = (
  id,
  startYear,
  endYear,
  granularityLevel,
  params,
  callback
) => {
  const axios = AxiosConfigBenchmarking();
  let url = `/author/concepts_map/?authorId=${id}`;
  if (startYear) {
    url = url + `&fromYear=${startYear}`;
  }
  if (endYear) {
    url = url + `&toYear=${endYear}`;
  }
  if (granularityLevel) {
    url = url + `&granularityLevel=${granularityLevel}`;
  }
  if (params) {
    url = url + `&rootConcept=${params}`;
  }

  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getAuthorRank = (data, callback) => {
  const axios = AxiosConfigBenchmarking();
  let url = `/author/rank`;

  var data_copy = {};
  Object.assign(data_copy, data);
  // data_copy["classification_strings"] = data_copy["classifications"];
  data_copy["keywordQuery"] = data_copy["keywords"];
  data_copy["keywordTimeFIlter"] = data_copy["time_range"];
  delete data_copy["classifications"];
  delete data_copy["keywords"];
  delete data_copy["time_range"];

  axios
    .post(url, data_copy)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getAuthorCompare = (data, callback) => {
  const axios = AxiosConfigBenchmarking();
  let url = `/author/compare`;

  axios
    .post(url, { candidates: data })
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getFacultyPublicationsById = (
  id,
  page,
  rowsPerPage,
  startYear,
  endYear,
  keywords,
  callback
) => {
  const axios = AxiosConfigBenchmarking();
  let url;
  if (keywords.length > 0) {
    let params = new URLSearchParams();
    keywords.forEach((keyword) => {
      if (keyword) {
        params.append("keyword", keyword.value);
      }
    });
    url = `/author/publications/?authorId=${id}&page=${page - 1
      }&rowsPerPage=${rowsPerPage}&fromYear=${startYear}&toYear=${endYear}&order_by=publication_year&order=desc&${params.toString()}`;
  } else {
    url = `/author/publications/?authorId=${id}&page=${page - 1
      }&rowsPerPage=${rowsPerPage}&fromYear=${startYear}&toYear=${endYear}&order_by=publication_year&order=desc`;
  }
  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getFacultyPeersById = (id, page, rowsPerPage, callback) => {
  const axios = AxiosConfigBenchmarking();
  const url = `/author/peers/?authorId=${id}&page=${page - 1
    }&rowsPerPage=${rowsPerPage}`;

  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};
